<div class="flex align-items-center justify-content-center font-bold m-2 text-3xl title-case">
    Internal Users
</div>
<p-card  styleClass="wrapper">
    <button pButton pRipple type="button" (click)="onAddNewUserClicked()" label="Add New User"></button>
    <p-table [value]="users" dataKey="usersId" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" responsiveLayout="scroll" [rowsPerPageOptions]="[10,25,50]">
        <ng-template pTemplate="header">
            <tr>
                <th>User Name</th>
                <th>Email</th>
                <th>User Role</th>
                <th>User Type</th>
                <th>Location</th>
                <th>Enabled</th>
                <th style="width:8rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr [pEditableRow]="user">
                <td>
                    {{user.firstName ?? ''}}
                    {{user.lastName ?? ''}}
                </td>
                <td>
                    {{user.email}}
                </td>
                <td>
                    {{user.roles ? user.roles[0].name : ''}}
                </td>
                <td>
                    {{user.userType}}
                </td>
                <td>
                    {{user.city}}
                </td>
                <td>
                    <p-inputSwitch 
                        (onChange)="onStatusSwitchChanged(user)"
                        [(ngModel)]="user.status"></p-inputSwitch>
                </td>
                <td style="text-align:center">
                    <button pButton pRipple type="button" pSaveEditableRow icon="pi pi-pencil" (click)="onRowEditClicked(user)" class="p-button-rounded p-button-success mr-2"></button>
                    <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-trash" (click)="onRowDeleted(user)" class="p-button-rounded p-button-danger"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
<p-toast styleClass="custom-toast" life="10000" position="top-center"></p-toast>
<p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>